import dayjs from 'dayjs';
import { LineChart, LineSeriesOption } from 'echarts/charts';
import {
  DataZoomComponent,
  DataZoomComponentOption,
  GridComponent,
  GridComponentOption,
  TitleComponent,
  TitleComponentOption,
  TooltipComponent,
  TooltipComponentOption,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import React, { useEffect, useRef } from 'react';

echarts.use([TitleComponent, TooltipComponent, GridComponent, DataZoomComponent, LineChart, CanvasRenderer, UniversalTransition]);

type EChartsOption = echarts.ComposeOption<TitleComponentOption | TooltipComponentOption | GridComponentOption | DataZoomComponentOption | LineSeriesOption>;

export interface LineDraggableChartProps {
  data: any;
  height?: number;
  range: number[];
}

const LineDraggableChart: React.FC<LineDraggableChartProps> = ({ data: cData, height = 400, range }) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const echartsRef = useRef<echarts.ECharts | null>(null);
  const dataRef = useRef<number[][]>([]);

  useEffect(() => {
    if (!chartRef.current || !cData || !cData.length) return;

    if (!echartsRef.current) {
      echartsRef.current = echarts.init(chartRef.current);
    }

    const chart = echartsRef.current;

    // 转换数据格式：将 {time, value} 转换为 [time, value] 数组
    dataRef.current = cData?.map((v: any) => [v.time, v.value]) || [];
    const data = dataRef.current;

    const option: EChartsOption = {
      title: {
        // text: 'Try Dragging these Points',
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        triggerOn: 'mousemove',
        axisPointer: {
          type: 'line',
        },
        formatter: function (params: any) {
          if (Array.isArray(params)) {
            const p = params[0];
            return 'X: ' + dayjs(p.data[0]).format('YYYY-MM-DD HH:mm:ss') + '<br>Y: ' + p.data[1].toFixed(2);
          }
          return 'X: ' + dayjs(params.data[0]).format('YYYY-MM-DD HH:mm:ss') + '<br>Y: ' + params.data[1].toFixed(2);
        },
      },
      grid: {
        top: '10%',
        bottom: '12%',
        left: 0,
        right: 0,
      },
      xAxis: {
        min: range[0],
        max: range[1],
        type: 'value',
        axisLine: { onZero: false },
        axisLabel: {
          formatter: (value: number) => dayjs(value).format('YYYY-MM-DD HH:mm:ss'),
        },
      },
      yAxis: {
        type: 'value',
        // axisLine: { onZero: false },
      },
      dataZoom: [
        {
          type: 'slider',
          xAxisIndex: 0,
          filterMode: 'none',
        },
        {
          type: 'inside',
          xAxisIndex: 0,
          filterMode: 'none',
        },
      ],
      series: [
        {
          id: 'a',
          type: 'line',
          smooth: true,
          showSymbol: false,
          data,
        },
      ],
    };

    chart.setOption(option);
  }, [cData, height]);

  return <div ref={chartRef} style={{ width: '100%', height: `${height}px`, minWidth: 0 }} />;
};

export default LineDraggableChart;
